import { useDispatch, useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";
import AgGridPaginatedTable from "../../components/AgGridPaginatedTable";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import {
  Box,
  Grid,
  Typography,
  Button,
  Paper,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import useErrorHandler from "../../hooks/useErrorHandler";
import {
  getDynamicViewDataList,
  getPageNameData,
  getSectionNameData,
} from "../../api/dynamic-view";
import { SalesOrdheaderTable } from "../../config/reactfile.js";
import React, { useEffect, useRef, useState } from "react";
import { Menu } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Checkbox from "@mui/material/Checkbox";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { getTransactionTypeDetail } from "../../api/transaction-type";
import { slugMap } from "../../config/slug-config";
import { Link, useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, isAfter, isToday } from "date-fns";
export default function DynamicView() {
  const [pageName, setPageName] = useState("Journal");
  const [sectionName, setSectionName] = useState("header");
  const dispatch = useDispatch();
  const errorHandler = useErrorHandler();
  const [anchorEl, setAnchorEl] = useState(null);
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  const [pageNameListData, setPageNameDataList] = useState([]);
  const [sectionNameListData, setsectionNameDataList] = useState([]);

  function refreshTable() {
    setTableRefreshCount((prev) => prev + 1);
  }
  const dateRef = useRef();
  const MemoRef = useRef();
  const docuRef = useRef();
  const [dateSortAscending, setDateSortAscending] = useState(true);
  const [dateChecked, setDateChecked] = useState(false);
  const [MemoChecked, setMemoChecked] = useState(false);
  const [docuChecked, setdocuChecked] = useState(false);
  const [idChecked, setidChecked] = useState(false);
  // date //

  const today = new Date();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  // date  //

  const [error, setError] = useState("");
  const open1 = Boolean(anchorEl);
  const handleClick1 = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose1 = (event) => {
    if (event.target.name === "memo") {
      setMemoChecked(event.target.checked);
      setDateChecked(dateChecked ? false : false);
      setdocuChecked(docuChecked ? false : false);
      setidChecked(false);
    }
    if (event.target.name === "date") {
      setDateChecked(event.target.checked);
      setMemoChecked(MemoChecked ? false : false);
      setdocuChecked(docuChecked ? false : false);
      setidChecked(false);
    }
    if (event.target.name === "documentno") {
      setdocuChecked(event.target.checked);
      setDateChecked(dateChecked ? false : false);
      setMemoChecked(MemoChecked ? false : false);
      setidChecked(false);
    }
    if (event.target.name === "internalid") {
      setdocuChecked(false);
      setDateChecked(dateChecked ? false : false);
      setMemoChecked(MemoChecked ? false : false);
      setidChecked(event.target.checked);
    }
    setInputSearch({});
    setSearchValue("");
    setStartDate("");
    setEndDate("");
    setAnchorEl(null);
  };
  const [onInputSearch, setInputSearch] = useState({});
  const [searchInputValue, setSearchValue] = useState("");
  const [date_For_validation, setDate_validation] = useState({});
  //console.log(params.slug);

  // let obj = JournalheaderTable.find((o) => o.headerName === "Action");
  // addAdditionalColumn(obj, dispatch);
  //get table data//
  // async function getdynamicViewData(limit, offset) {
  //   try {
  //     const combineData = { page_name: pageName, sec_name: sectionName };
  //     const { data } = await getDynamicViewDataList(user?.token, combineData, {
  //       limit,
  //       offset,
  //       transid: "",
  //     });
  //     return {
  //       rows: data.data.data,
  //       total: data.data.total,
  //       error: false,
  //     };
  //   } catch (error) {
  //     snackbar.showError(error);
  //     return { error: true };
  //   } finally {
  //     // setLoading(false)
  //   }
  // }
  async function getTransactionTypeDetailTableData(limit, offset) {
    try {
      const { data } = await getDynamicViewDataList(
        user?.token,
        onInputSearch
          ? {
              limit,
              offset,
              type: "SalesOrd",
              ...onInputSearch,
            }
          : {
              limit,
              offset,
              type: "SalesOrd",
            }
      );

      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      // setLoading(false)
    }
  }
  async function getPageNameList() {
    try {
      const { data } = await getPageNameData(user.token, {});
      setPageNameDataList(data.data.pageList);
    } catch (error) {
      errorHandler(error);
    } finally {
      // setLoading(false)
    }
  }
  async function getSectionNameList() {
    try {
      const { data } = await getSectionNameData(user.token, {
        page_name: pageName,
      });
      setsectionNameDataList(data.data.sectionList);
    } catch (error) {
      errorHandler(error);
    } finally {
      // setLoading(false)
    }
  }
  useEffect(() => {
    if (user.token) {
      getPageNameList();
      getSectionNameList();
    }
    return;
  }, []);
  // useEffect(() => {
  //   getSectionNameList();
  // }, [pageName]);
  useEffect(() => {
    refreshTable();
  }, [pageName, sectionName]);

  function onSortChanged() {
    setDateSortAscending((previous) => !previous);
    setTableRefreshCount((prev) => prev + 1);
  }

  function isStringInteger(value) {
    return (
      Number.isInteger(parseInt(value)) && value === parseInt(value).toString()
    );
  }

  const InputSearch = (event) => {
    if (isStringInteger(event.target.value) || docuChecked) {
      setInputSearch({ documentno: event.target.value });
      setSearchValue(event.target.value);
    } else if (event.target.value.includes("/")) {
      setInputSearch({ datefrom: event.target.value });
    } else if (MemoChecked) {
      setInputSearch({ memo: event.target.value });
    }
    if (!MemoChecked && !docuChecked && !idChecked && !dateChecked) {
      setInputSearch({ documentno: event.target.value });
      setSearchValue(event.target.value);
    }

    if (!event.target.value.includes("-")) {
      setSearchValue(event.target.value);
    }
  };

  const handleStartDateChange = (date) => {
    if (isAfter(date, today)) {
      // If the selected start date is after today, do not update the state
      return;
    }
    setStartDate(date);
    setInputSearch({
      ...onInputSearch,

      datefrom: format(date, "MM/dd/yyyy"),
    });
    // Ensure that the selected start date is always older than the end date
    if (endDate && isAfter(date, endDate)) {
      setEndDate(null);
    }
  };

  const handleEndDateChange = (date) => {
    if (isAfter(date, today)) {
      // If the selected end date is after today, do not update the state
      return;
    }

    // Ensure that the selected end date is always after the start date
    if (startDate && isAfter(startDate, date)) {
      return;
    }
    setInputSearch({
      ...onInputSearch,

      dateto: format(date, "MM/dd/yyyy"),
    });
    setEndDate(date);
  };
  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        pb={2}
      >
        <Typography component="h5" fontWeight={500} className="pageHeading1">
          Sales Order
        </Typography>
        <Button
          className="backBtn"
          onClick={() => {
            window.location.reload(); // Perform hard refresh after API call
          }}
        >
          Get latest column names
        </Button>
      </Box>

      {/* <Box component={Paper} p={2}>
        <Grid container spacing={2}>
          <Grid item md={3} sm={6} xs={12}>
            <FormControl fullWidth>
              <InputLabel id="page-name-label">Page Name</InputLabel>
              <Select
                labelId="page-name-label"
                id="page-name-select"
                value={pageName}
                label="Page Name"
                onChange={(e) => setPageName(e.target.value)}
              >
                {pageNameListData.map((item, i) => {
                  return (
                    <MenuItem value={item.pagename}>{item.pagename}</MenuItem>
                  );
                })}
               
              </Select>
            </FormControl>
          </Grid>

          <Grid item md={3} sm={6} xs={12}>
            <FormControl fullWidth>
              <InputLabel id="section-name-label">Section Name</InputLabel>
              <Select
                labelId="section-name-label"
                id="section-name-select"
                value={sectionName}
                label="Section Name"
                onChange={(e) => setSectionName(e.target.value)}
              >
                {sectionNameListData.map((item, i) => {
                  return (
                    <MenuItem value={item.sec_name}>{item.sec_name}</MenuItem>
                  );
                })}
              
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Box> */}
      <Box className="filter-box">
        <Grid container alignItems="center">
          <Grid item md={10} sm={12} xs={12}>
            <Grid container alignItems="center">
              <Grid item md={1} sm={1} xs={1}>
                <Button
                  id="basic-button1"
                  sx={{ color: "black", fontWeight: "600" }}
                  aria-controls={open1 ? "basic-menu1" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open1 ? "true" : undefined}
                  onClick={handleClick1}
                >
                  <SearchIcon /> <KeyboardArrowDownIcon />
                </Button>

                <Menu
                  id="basic-menu1"
                  anchorEl={anchorEl}
                  open={open1}
                  MenuListProps={{
                    "aria-labelledby": "basic-button1",
                  }}
                >
                  <MenuItem>
                    <Box>
                      <Checkbox
                        name="date"
                        checked={dateChecked}
                        ref={dateRef}
                        onClick={handleClose1}
                      />
                      Date
                    </Box>
                    <Box
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        width: "100%",
                        position: "relative",
                        top: "-16px",
                        left: "5px",
                      }}
                    >
                      <svg
                        onClick={handleClose1}
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        height={25}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M6 18L18 6M6 6l12 12"
                        ></path>
                      </svg>
                    </Box>
                  </MenuItem>

                  <MenuItem>
                    <Checkbox
                      name="memo"
                      checked={MemoChecked}
                      ref={MemoRef}
                      onClick={handleClose1}
                    />
                    Memo
                  </MenuItem>

                  <MenuItem>
                    <Checkbox
                      name="documentno"
                      checked={docuChecked}
                      ref={docuRef}
                      onClick={handleClose1}
                    />
                    Document No.
                  </MenuItem>
                  <MenuItem>
                    <Checkbox
                      name="internalid"
                      checked={idChecked}
                      ref={docuRef}
                      onClick={handleClose1}
                    />
                    View Id
                  </MenuItem>
                </Menu>
              </Grid>
              <Grid
                item
                md={9}
                sm={8}
                xs={9}
                alignItems="center"
                display="flex"
              >
                {/*  */}
                {dateChecked && (
                  <>
                    <Box
                      style={{
                        display: "flex",
                        gap: "5px",
                        justifyItems: "center",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <DatePicker
                          selected={startDate}
                          onChange={handleStartDateChange}
                          dateFormat="MM/dd/yyyy"
                          placeholderText="mm/dd/yyyy"
                          maxDate={today}
                          showIcon
                          showYearDropdown
                        />
                      </div>
                      to
                      <div>
                        <DatePicker
                          selected={endDate}
                          onChange={handleEndDateChange}
                          dateFormat="MM/dd/yyyy"
                          placeholderText="mm/dd/yyyy"
                          maxDate={today}
                          showIcon
                          showYearDropdown
                        />
                      </div>
                    </Box>
                  </>
                )}
                {!dateChecked && (
                  <TextField
                    type={dateChecked ? "date" : ""}
                    id="outlined-basic"
                    placeholder={`${
                      MemoChecked
                        ? "memo"
                        : docuChecked
                        ? "document no"
                        : idChecked
                        ? "view id"
                        : ""
                    }`}
                    size="small"
                    label=""
                    name={dateChecked ? "datefrom" : ""}
                    variant="outlined"
                    value={searchInputValue}
                    onChange={
                      idChecked
                        ? (e) => {
                            setInputSearch({ internalid: e.target.value });
                            setSearchValue(e.target.value);
                          }
                        : InputSearch
                    }
                    sx={{ pr: 1 }}
                  />
                )}

                <Button
                  size="small"
                  type="button"
                  sx={{ color: "black", fontWeight: "600" }}
                  onClick={(e) => handleClose1(e)}
                >
                  Reset
                </Button>
                {error && <p>{error}</p>}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <br />
      <Paper elevation={3}>
        <AgGridPaginatedTable
          getTableRows={getTransactionTypeDetailTableData}
          // columns={transactionTypeDetailSalesOrder}
          columns={SalesOrdheaderTable}
          perPage={20}
          refreshCounter={tableRefreshCount}
          onSortChanged={onSortChanged}
          onInputSearch={onInputSearch}
        />
        {/* <AgGridPaginatedTable
          getTableRows={getdynamicViewData}
          columns={JournalheaderTable}
          perPage={10}
          refreshCounter={tableRefreshCount}
        /> */}
      </Paper>
    </>
  );
}
function addAdditionalColumn(obj, dispatch) {
  if (obj === undefined) {
    SalesOrdheaderTable.unshift({
      headerName: "Action",
      field: "actions",
      maxWidth: 86,
      cellRendererFramework: (params) => (
        <Box>
          <Button
            className="actionIcon"
            onClick={() => {
              dispatch({ type: "DIALOG", data: params.data });
            }}
          >
            <EditOutlinedIcon />
          </Button>
        </Box>
      ),
    });
  }
}
